<template>
    <v-row justify="end">
        <v-tooltip
            bottom
            >
            <template v-slot:activator="{on}">
              <v-btn
                  @click.stop="editDialog.flag = true"
                  :color="mainColor"
                  outlined
                  icon
                  v-on="on"
              >
                <v-icon>{{editIcon}}</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
        </v-tooltip>
        <v-dialog width="650px" v-model="openDialog">
            <v-card>
                <edit-collab :user="userData" :dialog="editDialog"/>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mdiPencilOutline } from '@mdi/js'
import * as constants from '../../../../constants.json'

export default {
  props: ['user'],

  data () {
    return {
      editDialog: { flag: false },
      editIcon: mdiPencilOutline,
      mainColor: constants.MAINCOLOR
    }
  },

  computed: {
    onLoading () {
      return this.$store.getters.getLoading
    },

    openDialog () {
      return this.editDialog.flag
    },

    userData () {
      return this.user
    }
  }
}
</script>
